<script>
    export let disabled = false;
    export let action = () => {};
</script>

<style>
    .menu-toggle {
        color: #dddddd;
        pointer-events: none;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .menu-toggle.editable {
        cursor: pointer;
        color: #dddddd;
        pointer-events: all;
    }

    .menu-toggle.editable:hover {
        color: #454545;
    }
</style>

<div
    class="menu-toggle"
    class:editable={!disabled}
    on:mousedown={event => event.stopPropagation()}
    on:click|stopPropagation|preventDefault={action}
>
    <i class="fas fa-ellipsis-v"></i>
</div>
